"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.define-property");

var _this = this;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = require("classnames");

var getClassWithoutModifier = function getClassWithoutModifier(classNameToUse) {
  var classWithoutModifier = null;

  if (classNameToUse) {
    var classes = classNameToUse.split(' ').reverse();
    classWithoutModifier = classes.find(function (c) {
      return !!c;
    });
  }

  return classWithoutModifier;
};

var listClassModifier = function listClassModifier(classModifier) {
  if (classModifier) {
    return classModifier.split(' ');
  }

  return null;
};

var getComponentClassName = function getComponentClassName(className, classModifier, defaultClassName) {
  var classNameToUse = className || defaultClassName || null;
  var classWithoutModifier = getClassWithoutModifier(classNameToUse);
  var modifiers = listClassModifier(classModifier);
  var modifiersObject = {};

  if (modifiers) {
    modifiers.forEach(function (modifier) {
      if (/\S/.test(modifier)) {
        modifiersObject[classWithoutModifier + "--" + modifier] = classNameToUse;
      }
    }, _this);
  }

  var componentClassName = classnames_1["default"](classNameToUse, modifiersObject);
  return componentClassName;
};

exports["default"] = {
  getComponentClassName: getComponentClassName
};